import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import WhatsAppShareModal from './WhatsAppShareModal';

/**
 * Sales > Product Catalog > Share catalog: choose what the catalog shows (everything or one category, prices, whether each product is in
 * stock), then the usual WhatsApp or email message with a link that opens it without logging in.
 */
function CatalogShareModal({ categories = [], onHide }) {
  const [category, setCategory] = useState('');
  const [prices, setPrices] = useState(true);
  const [availability, setAvailability] = useState(false);
  const [options, setOptions] = useState(null);

  if (options) {
    return <WhatsAppShareModal path="catalog" title="Send the product catalog" what="catalog" party="recipient" offerUpi={false} days={90}
      options={options} onHide={onHide} />;
  }
  return (
    <Modal show onHide={onHide} centered>
      <Modal.Header closeButton><Modal.Title as="h5">Share the product catalog</Modal.Title></Modal.Header>
      <Modal.Body>
        <p className="small text-muted">
          A page with your products, their photos and prices that anyone you send the link to can open, without logging in. It always shows
          your products as they are on the day it is opened.
        </p>
        <Form.Group className="mb-3">
          <Form.Label>Which products</Form.Label>
          <Form.Select value={category} onChange={(e) => setCategory(e.target.value)} data-testid="catalog-category">
            <option value="">All products</option>
            {categories.map((c) => <option key={c} value={c}>{c}</option>)}
          </Form.Select>
        </Form.Group>
        <Form.Check type="switch" id="catalog-prices" className="mb-2" label="Show prices (with the GST rate)" checked={prices} onChange={(e) => setPrices(e.target.checked)} />
        <Form.Check type="switch" id="catalog-availability" label="Show whether each product is in stock" checked={availability} onChange={(e) => setAvailability(e.target.checked)} />
        <Form.Text className="text-muted d-block mt-1">Only &ldquo;in stock&rdquo; or &ldquo;out of stock&rdquo; is shown, never how many you have.</Form.Text>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" onClick={() => setOptions({ category: category || undefined, prices, availability })} data-testid="catalog-continue">Continue</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CatalogShareModal;
